if (!customElements.get("m-collection-list")) {
  class MCollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
        slideInner: ".m-mixed-layout__inner",
      };
      this.classes = {
        grid: 'm:grid',
        hidden: 'm:hidden',
        swiper: 'swiper-container',
        swiperWrapper: 'swiper-wrapper'
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.slider = false;

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.total = this.dataset.total;
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = this.dataset.autoplaySpeed;
      this.paginationType = this.dataset.paginationType;
      this.expanded = this.dataset.expanded === "true";
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";

      this.init();
      document.addEventListener("matchMobile", () => {
        this.init();
      });
      document.addEventListener("unmatchMobile", () => {
        this.init();
      });
    }

    init() {
      if (!this.enableSlider) return;
      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const { slideContainer, slideControls, slideInner } = queryDomNodes(this.selectors, this);

      const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
      const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;

      /*
       * Si hay al menos un slide marcado como "doble ancho"
       * (clase agregada por el checkbox "Ocupar doble ancho" del bloque banner),
       * el breakpoint de escritorio (1280) usa slidesPerView: 'auto' para que
       * cada slide tome el ancho definido por CSS (ver collection-list.liquid)
       * en vez de un ancho fijo calculado por Swiper.
       */
      const hasWideSlide = !!this.querySelector(".m-collection-list__item--wide");
      const desktopSlidesPerView = hasWideSlide
        ? "auto"
        : (this.expanded && this.total > this.items ? parseInt(this.items) + 1 : parseInt(this.items));

      this.options = {
        slidesPerView: 2,
        loop: !hasWideSlide,
        slidesPerGroup: 1,
        showNavigation: true,
        showPagination: true,
        parallax: true,
        autoplay: this.autoplay
          ? {
            delay: parseInt(this.autoplaySpeed) * 1000,
          }
          : false,
        pagination:
          this.paginationType == "fraction"
            ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              type: "fraction",
            }
            : {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
              renderBullet: function (index, className) {
                return '<span class="' + className + '">' + paginationIcon + "</span>";
              },
            },
        navigation: nextButton || prevButton ? {
          nextEl: nextButton && nextButton,
          prevEl: prevButton && prevButton
        } : false,
        autoHeight: true,
        breakpoints: {
          480: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
          },
          1280: {
            slidesPerView: desktopSlidesPerView,
          },
        }
      };

      if (typeof this.slider !== 'object') {
        slideContainer.classList.add(this.classes.swiper);
        slideInner.classList.remove(this.classes.grid);
        slideInner.classList.add(this.classes.swiperWrapper);
        slideControls && slideControls.classList.remove(this.classes.hidden);
        this.slider = new MinimogLibs.Swiper(slideContainer, this.options);

        if (hasWideSlide) {
          this.syncWideSlideWidths();
          window.addEventListener("load", () => this.syncWideSlideWidths());
          this.slider.on("resize", () => this.syncWideSlideWidths());
          window.addEventListener("resize", () => {
            clearTimeout(this._wideResizeTimeout);
            this._wideResizeTimeout = setTimeout(() => this.syncWideSlideWidths(), 100);
          });
        }
      }
    }

    /*
     * Mide el ancho real ya renderizado de un slide normal y el gap real
     * entre dos slides normales consecutivos (tal cual los aplica el tema,
     * sin asumir el valor exacto de --column-gap), y fija el ancho del
     * slide "wide" como el doble del normal más ese gap medido.
     * Solo aplica en el breakpoint de escritorio (>=1280px); en mobile/tablet
     * se limpia el ancho inline para que el slide wide se comporte normal.
     */
    syncWideSlideWidths() {
      const isRealSlide = (s) => !s.classList.contains("swiper-slide-duplicate");
      const slides = Array.from(this.querySelectorAll(".swiper-slide")).filter(isRealSlide);
      const wideSlides = slides.filter((s) => s.classList.contains("m-collection-list__item--wide"));
      const normalSlides = slides.filter((s) => !s.classList.contains("m-collection-list__item--wide"));

      if (!wideSlides.length || normalSlides.length < 1) return;

      if (window.innerWidth < 1280) {
        wideSlides.forEach((s) => {
          s.style.removeProperty("width");
          const wideMedia = s.querySelector(".m-collection-banner-v2__media");
          if (wideMedia) {
            wideMedia.style.removeProperty("height");
          }
        });
        this.slider && this.slider.update && this.slider.update();
        return;
      }

      const normalRect = normalSlides[0].getBoundingClientRect();
      let gap = 0;
      if (normalSlides.length > 1) {
        const r1 = normalSlides[0].getBoundingClientRect();
        const r2 = normalSlides[1].getBoundingClientRect();
        gap = r2.left - r1.right;
      }

      const wideWidth = normalRect.width * 2 + gap;

      wideSlides.forEach((s) => {
        s.style.setProperty("width", wideWidth + "px", "important");
      });

      /*
       * Copia el alto EXACTO (en px) del media normal al media wide,
       * en vez de confiar en el cálculo matemático de aspect-ratio,
       * para eliminar cualquier residuo de redondeo del navegador.
       */
      const normalMedia = normalSlides[0].querySelector(".m-collection-banner-v2__media");
      if (normalMedia) {
        const targetHeight = normalMedia.getBoundingClientRect().height;
        wideSlides.forEach((s) => {
          const wideMedia = s.querySelector(".m-collection-banner-v2__media");
          if (wideMedia) {
            wideMedia.style.setProperty("height", targetHeight + "px", "important");
          }
        });
      }

      this.slider && this.slider.update && this.slider.update();
    }

    destroySlider() {
      const { slideContainer, slideControls, slideInner } = queryDomNodes(this.selectors, this);

      slideContainer.classList.remove(this.classes.swiper);
      slideInner.classList.remove(this.classes.swiperWrapper);
      slideInner.classList.add(this.classes.grid);
      slideControls && slideControls.classList.add(this.classes.hidden);

      if (typeof this.slider === 'object') {
        this.slider.destroy();
        this.slider = false;
      }
    }
  }

  customElements.define("m-collection-list", MCollectionList);
}